import { Typography } from "@circle-react-shared/uikit/Typography";

interface BlockStepProps {
  title: string;
}

export const BlockStep = ({ title }: BlockStepProps) => (
  <div className="bg-secondary border-primary absolute top-[-0.875rem] rounded-[1.375rem] border px-3 py-0.5">
    <Typography.BodySm color="text-dark" weight="normal">
      {title}
    </Typography.BodySm>
  </div>
);
